//local imports
import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";

import classes from "@/styles/developers/become-a-developer-main.module.css";
import { becomeADeveloper } from "@/utils/content";
import { becomeDeveloperService } from "@/services/connectWithUsServices";
import useAlertBar from "@/hooks/useAlertBar";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function BecomeADeveloperMain() {
  const content = becomeADeveloper.en;
  const { openAlertBar } = useAlertBar();
  const [loading, setLoading] = useState(false);
  const isMobile = useIsMobile();

  const [fd, setFd] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    companyEmail: "",
    phone: "",
    businessType: "",
    location: "",
    comments: "",
  });

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setFd({
      ...fd,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    //api call
    let res = await becomeDeveloperService(fd);

    if (res.data.status) {
      setLoading(false);
      openAlertBar("We have received you request, Thank you!", true);
    } else {
      setLoading(false);
      openAlertBar(
        "Unexpected error occurred while sending your request",
        false
      );
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.hero}>
        <h1 className={`text-white mx-auto ${isMobile ? "w-100" : "w-50"}`}>
          {content.title}
        </h1>
      </div>
      <section className="pb-5 col-sm-8 col-md-8 col-lg-6 mx-auto">
        <Card className={classes.formCard}>
          <CardBody>
            <Form onSubmit={onSubmit}>
              <Row>
                <Col xs={12} md={6}>
                  <Label>{content.form.firstName} *</Label>
                  <Input
                    type="text"
                    name="firstName"
                    onChange={onChange}
                    value={fd.firstName}
                    placeholder={content.form.firstName}
                    required
                  />
                </Col>
                <Col className={isMobile ? "my-3" : ""} xs={12} md={6}>
                  <Label>{content.form.lastName} *</Label>
                  <Input
                    type="text"
                    name="lastName"
                    onChange={onChange}
                    value={fd.lastName}
                    placeholder={content.form.lastName}
                    required
                  />
                </Col>
              </Row>
              <div className="my-3">
                <Label>{content.form.companyEmail} *</Label>
                <Input
                  type="email"
                  name="companyEmail"
                  onChange={onChange}
                  value={fd.companyEmail}
                  placeholder={content.form.companyEmail}
                  required
                />
              </div>
              <div className="my-3">
                <Label>{content.form.companyName} *</Label>
                <Input
                  type="text"
                  name="companyName"
                  onChange={onChange}
                  value={fd.companyName}
                  placeholder={content.form.companyName}
                  required
                />
              </div>
              <div className="my-3">
                <Label>
                  {content.form.phoneNumber} ({content.form.optional})
                </Label>
                <Input
                  type="tel"
                  name="phone"
                  onChange={onChange}
                  value={fd.phone}
                  placeholder={content.form.phoneNumber}
                />
              </div>
              <div className="my-3">
                <Label>{content.form.businessType}</Label>
                <Input
                  type="select"
                  name="businessType"
                  onChange={onChange}
                  required
                >
                  <option disabled>Please Select</option>
                  <option>Warehouse</option>
                  <option>Technology Partner</option>
                  <option>Fulfillment Partner</option>
                  <option>Agency</option>
                </Input>
              </div>
              <div className="my-3">
                <Label>{content.form.location}</Label>
                <Input
                  type="select"
                  name="location"
                  onChange={onChange}
                  required
                >
                  <option disabled>Please Select</option>
                  <option>Canada</option>
                  <option>USA</option>
                  <option>Rest of World</option>
                </Input>
              </div>
              <div className="my-3">
                <Label>{content.form.comments}</Label>
                <Input
                  type="textarea"
                  name="comments"
                  onChange={onChange}
                  value={fd.comments}
                  placeholder={content.form.comments}
                ></Input>
              </div>
              <div className="text-center">
                <Button className={classes.btn}>
                  {content.applyNow}

                  {loading && <Spinner size="sm" className="ms-3" />}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </section>
      <section
        className={`container text-center ${isMobile ? "" : "w-75 my-5 py-5"}`}
      >
        <h3 className={classes.h3}>{content.title2}</h3>
        <p className={classes.p}>{content.para2}</p>
      </section>
    </div>
  );
}
